import { useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";
import { Star } from "@phosphor-icons/react";
import { WHATSAPP } from "@/components/public/PublicNav";

export default function Menu() {
  const [products, setProducts] = useState([]);
  const [activeCat, setActiveCat] = useState("Todos");

  useEffect(() => {
    api.get("/products/public").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  const categories = useMemo(() => {
    const set = new Set(products.map((p) => p.category));
    return ["Todos", ...Array.from(set)];
  }, [products]);

  const filtered = activeCat === "Todos" ? products : products.filter((p) => p.category === activeCat);

  return (
    <div>
      <section className="max-w-7xl mx-auto px-6 pt-16 pb-10">
        <div className="text-xs uppercase tracking-[0.25em] text-brand font-semibold mb-3">Carta Digital</div>
        <h1 className="font-display text-5xl md:text-7xl font-black tracking-tight leading-[0.95]">
          Nuestra carta,<br />honesta y bien servida.
        </h1>
        <p className="text-zinc-600 mt-6 max-w-2xl text-lg">Precios claros, ingredientes frescos, recetas tradicionales. ¿Listo para elegir?</p>
      </section>

      <section className="sticky top-20 z-30 bg-[var(--bg-public)]/85 backdrop-blur-xl border-y border-zinc-200">
        <div className="max-w-7xl mx-auto px-6 py-4 flex gap-2 overflow-x-auto pos-scroll">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setActiveCat(c)}
              data-testid={`menu-cat-${c.toLowerCase()}`}
              className={`px-5 h-11 rounded-full whitespace-nowrap font-semibold text-sm transition-all border-2 ${
                activeCat === c ? "bg-brand text-white border-brand" : "bg-white text-zinc-700 border-zinc-200 hover:border-brand"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((p) => (
            <article key={p.id} data-testid={`menu-item-${p.id}`} className="group bg-white rounded-3xl overflow-hidden border border-zinc-200 hover:-translate-y-1 hover:shadow-xl transition-all duration-300">
              <div className="aspect-[4/3] bg-zinc-100 overflow-hidden relative">
                {p.image_url ? (
                  <img src={p.image_url} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-zinc-300 font-display text-5xl">{p.category.charAt(0)}</div>
                )}
                {p.top_seller && (
                  <div className="absolute top-3 left-3 inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-orange-500 text-white text-xs font-bold uppercase tracking-wider">
                    <Star size={12} weight="fill" /> Top
                  </div>
                )}
              </div>
              <div className="p-5">
                <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-400 mb-1">{p.category}</div>
                <div className="flex items-baseline justify-between gap-3">
                  <h3 className="font-display text-xl font-bold leading-tight">{p.name}</h3>
                  <div className="font-display text-2xl font-black text-brand">${p.price}</div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-20 text-zinc-500">No hay productos en esta categoría.</div>
        )}
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-20">
        <a href={WHATSAPP} target="_blank" rel="noreferrer" data-testid="menu-whatsapp" className="block bg-emerald-500 hover:bg-emerald-600 transition-colors rounded-3xl p-10 text-center text-white">
          <div className="font-display text-3xl md:text-4xl font-black">Pídelos por WhatsApp</div>
          <div className="opacity-90 mt-2">Te contestamos en minutos · Pago en efectivo o tarjeta al recibir</div>
        </a>
      </section>
    </div>
  );
}
